import { useState } from 'react';
import { IMediaAndContent } from '../../../interfaces/MediaAndContent'
import { Parser } from "html-to-react";
import { MdShare } from 'react-icons/md';
import Button from '../../../components/Buttons/Button';
import DateWithIcon from '../../../components/Common/DateWithIcon';
import ChipsMapper from '../../../components/Mappers/ChipsMapper';
import Dialog from '../../../components/Dialog/Dialog';
import Share from '../../../components/Share/Share';
import SEO from '../../../components/SEO/SEO';
import DownloadPDFButton from '../../../components/DownloadPDF/DownloadPDFButton';
const { REACT_APP_BACKOFFICE_CONNECTION, REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH } = process.env;

interface IDetailOfMedia extends IMediaAndContent {
    module: string
}

const DetailOfMedia = ({ titulo, fecha, descripcion = '', categorias, imagen, texto, pdf, module, imagen_pie_1, imagen_pie_2, imagen_pie_3 }: IDetailOfMedia) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const href = window.location.href;
    const isMetodologia = window.location.pathname.includes('metodologia');

    const buildUrl = (path: string) =>
        `${REACT_APP_BACKOFFICE_CONNECTION}${REACT_APP_BACKOFFICE_FILE_UPLOAD_PATH}${path.replace("files/", "")}`;

    const imageClassName = isMetodologia
        ? 'h-[200px] rounded-sm'
        : 'h-[224px] sm:h-[18.12rem] md:h-[464px] xl:h-[39.718125rem] w-full rounded-sm';

    const footerImages = [imagen_pie_1, imagen_pie_2, imagen_pie_3].filter(img => img?.length);

    return (
        <>
            <SEO
                title={titulo}
                description={descripcion}
                name='Monitor de derechos CABA'
                type='article'
                image={buildUrl(imagen)}
                url={href}
            />
            <div className='flex flex-col gap-4 mt-6'>
                <h1 className='text-brand-green-20 text-hmedium md:text-dsmall'>{titulo}</h1>
                <DateWithIcon date={fecha} />
                <ChipsMapper categorias={categorias} />
            </div>
            <div className='my-8 w-full'>
                <img src={buildUrl(imagen)} className={`${imageClassName} object-cover`} />
            </div>
            <div className='flex flex-col gap-8'>
                <div className='text-blarge text-[#2C3134]'>
                    {Parser().parse(texto)}
                </div>
                {footerImages.map((img, index) => (
                    <img
                        key={index}
                        src={buildUrl(img ?? '')}
                        className={`h-full w-full object-cover`}
                    />
                ))}
                <div className='flex gap-1 justify-end'>
                    {pdf && pdf.length > 0 && (
                        <DownloadPDFButton
                            pdfUrl={buildUrl(pdf)}
                            fileName={pdf.replace("files/", "")}
                            module={module}
                            source="detalle"
                            className='text-system-light-40'
                        />
                    )}
                    <Button
                        label='Compartir'
                        as='link'
                        icon={MdShare}
                        className='text-system-light-40'
                        showIconLeft={true}
                        showIconRight={false}
                        onClick={() => setIsOpen(!isOpen)}
                    />
                </div>
            </div>
            <Dialog isOpen={isOpen} toggle={() => setIsOpen(!isOpen)}>
                <Share newsTitle={titulo} newsUrl={href} description={descripcion} />
            </Dialog>
        </>
    );
};

export default DetailOfMedia